import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';

const GTM_ID = 'GTM-P7LMLWS9';

// Pages to exclude from GTM tracking
const EXCLUDED_PATHS = ['/login', '/register'];

export default function GoogleTagManager() {
  const location = useLocation();

  useEffect(() => {
    // Check if current path should be excluded (with or without trailing slash)
    const currentPath = location.pathname.replace(/\/$/, ''); // Remove trailing slash for comparison
    const isExcluded = EXCLUDED_PATHS.some(path => currentPath === path);

    if (isExcluded) {
      // Remove GTM if on excluded page
      return;
    }

    // Initialize dataLayer if not exists
    window.dataLayer = window.dataLayer || [];
    
    // Check if GTM script already loaded
    if (!document.getElementById('gtm-script')) {
      // Add GTM script to head
      const script = document.createElement('script');
      script.id = 'gtm-script';
      script.innerHTML = `
        (function(w,d,s,l,i){w[l]=w[l]||[];w[l].push({'gtm.start':
        new Date().getTime(),event:'gtm.js'});var f=d.getElementsByTagName(s)[0],
        j=d.createElement(s),dl=l!='dataLayer'?'&l='+l:'';j.async=true;j.src=
        'https://www.googletagmanager.com/gtm.js?id='+i+dl;f.parentNode.insertBefore(j,f);
        })(window,document,'script','dataLayer','${GTM_ID}');
      `;
      document.head.insertBefore(script, document.head.firstChild);
    }

    // Check if noscript iframe already exists
    if (!document.getElementById('gtm-noscript')) {
      // Add noscript iframe after body opening
      const noscript = document.createElement('noscript');
      noscript.id = 'gtm-noscript';
      noscript.innerHTML = `<iframe src="https://www.googletagmanager.com/ns.html?id=${GTM_ID}" height="0" width="0" style="display:none;visibility:hidden"></iframe>`;
      document.body.insertBefore(noscript, document.body.firstChild);
    }

    // Push page view event on route change
    window.dataLayer.push({
      event: 'pageview',
      page: location.pathname + location.search
    });

  }, [location]);

  return null;
}
